import Box from "@mui/material/Box";
import headerLogo from "assets/images/footerLogo2.png";

// const InfoWithDivider = ({ text }) => {
//   if (text !== undefined)
//     return (
//       <>
//         <Typography noWrap sx={{ cursor: "pointer", px: 2, fontSize: 12 }}>
//           {text}
//         </Typography>
//         <Divider orientation="vertical" sx={{ borderWidth: 1 }} />
//       </>
//     );
//   else return null;
// };

const Footer = () => {
  // const user = useSelector((storeState) => storeState?.auth);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        height: "100%",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <div></div>
      <img
        src={headerLogo}
        onClick={() => window.open("https://www.qubiteq.gr")}
        alt="Xcelvations Logo"
        height="34px"
        style={{ cursor: "pointer", paddingRight: 4 }}
      />
      {/* {cmp && year && user && (
          <>
            <InfoWithDivider text={cmp?.cmpName} />
            <InfoWithDivider text={cmp?.cmpAFM} />
            <InfoWithDivider text={year?.yrsAbbr} />
            <InfoWithDivider text={year?.currAbbr} />
            <InfoWithDivider text={user?.userName} />
            <InfoWithDivider text={user?.userFullName} />
          </>
        )} */}
    </Box>
  );
};

export default Footer;
